module.exports = __webpack_public_path__ + "static/media/BellDot.9b3a4a11.svg";